import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IProject } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ProjectAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addProject(project: IProject): Observable<string> {
    return this.post<string>(`/admin/projects`, `v1`, {
      name: project.name,
      isActive: project.isActive,
      username: project.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('project')));
  }

  public getProject(id: string): Observable<IProject> {
    return this.get<IProject>(`/admin/projects/${id}`, 'v1');
  }

  public getProjects(includeInActive: boolean | null | undefined): Observable<IProject[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IProject[]>(`/admin/projects`, 'v1').pipe(
      map((results) => [...results].filter((x: IProject) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IProject, b: IProject) => (a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1))
      )
    );
  }

  public getProjectsAll(): Observable<IProject[]> {
    return this.getProjects(true);
  }

  public updateProject(project: IProject): Observable<any> {
    return this.put<IProject>(`/admin/projects/${project.id}`, `v1`, {
      id: project.id,
      name: project.name,
      isActive: project.isActive,
      username: project.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('project')));
  }
}
